import { Component, ViewChild, OnInit, TemplateRef, Input, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { concatMap, tap, finalize, catchError } from 'rxjs/operators';
import { qmsService } from '../qms.service';
import { from, of } from 'rxjs';
import { CheckListConfig } from 'src/app/support/models/check-list.model';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements OnInit {

  @Input() checkList: CheckListConfig;
  @Output() popupClosed = new EventEmitter<void>();

  refNo: any;

  tempCheckListFields: any = [];
  checkListFields: any = [];
  field: any = {};

  isProcessing: boolean = false;
  isAdding: boolean = false;
  isWarning: boolean = false;

  template: any = null;
  storedTemplateId: any = null;

  templateList: any = [];
  criteriaList: any = [];

  templateDropDown: any = [];

  templateSearchText: string = '';
  dropDownSearchText: string = '';

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    readonly qualityService: qmsService,
    readonly message: messageService,

    private readonly dialog: MatDialog,
    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
  ) {
    this.refNo = this.qualityService.activityId;

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  cancelCheckListPopup() {
    this.visibleCheckListPopup.close();
    this.popupClosed.emit();
  }

  @ViewChild('checkListPopup', { static: true }) checkListPopup: TemplateRef<any>;
  visibleCheckListPopup: MatDialogRef<TemplateRef<any>>;

  checkListPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  ngOnInit() {
    this.isProcessing = true;
    this.checkListFields = [];
    this.getTemplates();
    this.getCheckLists();
    setTimeout(() => this.visibleCheckListPopup = this.dialog.open(this.checkListPopup, this.checkListPopupConfig));
  }

  private getTemplates(): void {
    this.appService.getAllCheckListTemplateByModule(this.qualityService.moduleName).subscribe((template: any) => {
      this.templateList = template.filter((x: any) => this.checkList.templateIds.split(',').map(Number).includes(x.templateId));
      this.selectBoxForTemplate();
    });
  }

  private selectBoxForTemplate(): void {
    this.templateDropDown = this.templateList?.filter((field: any) => field.isActive == 'Y')?.map((type: any) => ({
      valueExp: type.templateId,
      displayExp: type.templateName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onTemplateSelect(event: any, item: any): void {
    if (event.isUserInput) {
      console.log("Selected");
      this.isProcessing = true;
      this.isWarning = this.checkListFields.length && this.storedTemplateId != +item.valueExp;
      this.appService.geAllCheckListTemplateFieldsByTemplateId(+item.valueExp).subscribe((fields: any) => {
        this.tempCheckListFields = fields;
        if (this.tempCheckListFields.length) {
          this.tempCheckListFields = this.tempCheckListFields.sort((a: any, b: any) => a.fieldSeq - b.fieldSeq);
        } else {
          this.showSnackBar("No fields found or fields are inactive. Please contact the admin.", "E");
          setTimeout(() => this.template = null);
        }
        this.isProcessing = false;
      })
    }
  }

  private getCheckLists(): void {
    this.appService.getAllCheckList(this.refNo, this.checkList.stageName).subscribe((fields: any) => {
      if (!fields?.length) { this.isProcessing = false; return };

      fields.forEach((el: any) => {
        el.fieldValues = el.fieldValues?.split(',') ?? null;

        this.template = this.storedTemplateId = el.templateId;

        if (['Drop Down', 'Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button', 'Vertical Radio Button', 'Horizontal Radio Button'].includes(el.fieldTypeCode)) {
          el.dd = el.response ? el.response.split(',') : [];

        } else if (el.fieldTypeCode == 'Date Field') {
          el.response = el.response ? new Date(el.response) : null;
        }
      });
      this.isProcessing = false;
      this.checkListFields = fields;
    });
  }

  public focusSearch(value: any): void {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus() }, 0)
  }

  popupTitle: string = '';
  responses: any[] = [];
  public create(): void {

    const fields = this.tempCheckListFields?.filter((field: any) => field.isActive == 'Y').sort((a: any, b: any) => a.fieldSeq - b.fieldSeq) ?? [];

    this.isAdding = true;
    this.isProcessing = true;
    this.responses = [];

    from(fields).pipe(
      concatMap((field: any, index: number) => {

        if (field.fieldTypeCode === 'Drop Down' || field.fieldTypeCode === 'Multiselect Drop Down' || field.questionTypeCode === 'Vertical Checkbox Button' || field.questionTypeCode === 'Horizontal Checkbox Button' || field.questionTypeCode === 'Vertical Radio Button' || field.questionTypeCode === 'Horizontal Radio Button') {
          field.response = field.response?.length ? field.response.join(',') : null;
        } else if (field.fieldTypeCode === 'Date Field') {
          field.response = field.response ? new Date(field.response) : null;
        }

        const obj = {
          seq: field.seq,
          fieldName: field.fieldName,
          fieldTypeCode: field.fieldTypeCode,
          fieldValues: field.fieldValues,
          module: this.qualityService.moduleName,
          response: null,
          justification: null,
          remarks: null,
          refNo: this.refNo,
          stageName: this.checkList.stageName,
          templateId: this.template
        };

        console.log("Sending →", obj);

        return this.appService.createCheckList(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {

        const resultCounter = this.responses.filter(x => x.response?.resultType === 'E').length;

        if (resultCounter) {
          this.isProcessing = false;
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        } else {
          this.isProcessing = false;
          this.getCheckLists();
          this.showSnackBar('Field(s) has been updated successfully!', 'S');
        }
      })
    ).subscribe();
  }

  update() {

    if (!this.isChangeDetected && !this.isWarning) { this.showSnackBar('No changes Detected!', 'E'); return; }

    if (this.isWarning) { this.deleteMethod(); return; }

    if (!this.checkListFields.length) return;

    for (let f of this.checkListFields) {
      if (['Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button'].includes(f.fieldTypeCode)) {
        f.response = f?.dd?.length ? f.dd.join(',') : null;
      } else if (f.fieldTypeCode === 'Date Field') {
        f.response = f.response ? new Date(f.response) : null;
      }
    }

    this.isProcessing = true;
    this.isAdding = false;
    this.isChangeDetected = false;
    this.responses = [];

    from(this.checkListFields).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          fieldId: field.fieldId,
          fieldSeq: field.fieldSeq,
          fieldName: field.fieldName,
          fieldTypeCode: field.fieldTypeCode,
          fieldValues: field.fieldValues?.join(',') ?? null,
          module: this.qualityService.moduleName,
          response: field.response,
          justification: field.justification,
          remarks: field.remarks,
          refNo: this.refNo,
          stageName: this.checkList.stageName,
          templateId: this.template
        };

        console.log("Updating →", obj);

        return this.appService.updateCheckList(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Failed to update:", field, error);
            this.showSnackBar("One update failed", "E");
            return of(null);  /* Continue to next */
          })
        );
      }),
      finalize(() => {
        const resultCounter = this.responses.filter(x => x.response?.resultType === 'E').length;

        if (resultCounter) {
          this.isProcessing = false;
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        } else {
          this.isProcessing = false;
          this.getCheckLists();
          this.showSnackBar('Field(s) has been updated successfully!', 'S');
        }
      })
    ).subscribe();
  }


  deleteMethod() {
    this.isProcessing = true;
    this.responses = [];

    from(this.checkListFields).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          fieldId: field.fieldId,
          refNo: field.refNo,
          fieldName: field.fieldName,
          deleteReason: 'Changed Template'
        };

        console.log("Sending →", obj);

        return this.appService.deleteCheckList(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.isWarning = false;
        this.create();
      })
    ).subscribe();
  }

  @ViewChildren('multiselect') multiselect!: QueryList<MatSelect>;
  multiSelection: boolean = false;

  toggleAllSelection(value: any, field: any) {
    if (value === 'multiselect') {
      const targetSelect = this.multiselect.find((select: MatSelect) =>
        select._elementRef.nativeElement.dataset.fieldId == field.fieldId
      );

      if (targetSelect) {
        if (field.multiSelection) {
          targetSelect.options.forEach((item: MatOption) => item.select());
        } else {
          targetSelect.options.forEach((item: MatOption) => item.deselect());
          field.dd = [];
        }
      }
    }
  }

  onMultiSelect(event: any, field: any) {
    if (event.isUserInput) {
      setTimeout(() => { field.multiSelection = field.fieldValues.length == field.dd.length; })
    }
  }

  onCheckboxChange(event: any, value: string, field: any): void {
    if (event.checked) {
      field.dd.push(value);
    } else {
      let index = field.dd.indexOf(value);
      field.dd.splice(index, 1)
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'category-name');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    adaptivePosition: true,
  };

  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;

  resultPopupConfig = {
    width: '32%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  cancelResultPopup() {
    this.visibleResultPopup.close();
  }

  isChangeDetected: boolean = false;
  public changeDetected(): void {
    this.isChangeDetected = true;
  }

}
